import React, { FC } from 'react';
import { isWeb, triggerRemovePI } from '@helpers';
import { connect } from 'react-redux';
import ActionMenu from '@components/common/actionMenu';
import { ColorFunction } from '@styles/colors/types';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { PartSearchItem } from '@interfaces/search';
import { setIsRemovingPI } from '@reducers/machinesV2';
import { addProductionInformationV2, removeProductionInformation } from '@reducers/manufacture';
import { RemoveProductionInformation } from '@interfaces/methods';
import { setIsEditModeForPartSwitchOn } from '@reducers/details';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

interface PartModalProps {
  C: ColorFunction;
  setActionsModalOpen: (state: boolean) => void;
  parts: ReducerEntityWithLoadingState<PartSearchItem[]>;
  minWidth?: number;
  isRemovingPI: boolean;
  setIsRemovingPI: (state: boolean) => void;
  removeProductionInformation: RemoveProductionInformation;
  addProductionInformationV2: (params: Record<string, unknown>) => Promise<void>;
  isEditModeForPartSwitchOn: boolean;
  setIsEditModeForPartSwitchOn: (state: boolean) => void;
}

const PartModal: FC<PartModalProps> = (props) => {
  const {
    setActionsModalOpen,
    C,
    parts,
    minWidth,
    isRemovingPI,
    removeProductionInformation,
    setIsRemovingPI,
    setIsEditModeForPartSwitchOn,
  } = props;

  const onEditPress = () => setIsEditModeForPartSwitchOn(true);

  const items = [
    {
      testID: TEST_IDS.detailsModal.part.edit,
      lable: {
        color: 'Label/Light/Primary',
        name: 'Edit',
      },
      icon: {
        name: 'edit',
        width: isWeb ? 15 : 12,
        height: isWeb ? 15 : 12,
        color: 'Label/Light/Primary',
      },
      onPress: () => {
        setActionsModalOpen(false);
        onEditPress();
      },
    },
    {
      testID: TEST_IDS.detailsModal.part.delete,
      lable: {
        color: 'Label/Light/Warning',
        name: 'Delete',
      },
      icon: {
        name: 'remove',
        width: isWeb ? 17 : 15,
        height: isWeb ? 18 : 17,
        color: 'Label/Light/Warning',
      },
      isLoading: isRemovingPI,
      onPress: () =>
        triggerRemovePI({
          params: { partId: parts?.data?.[0]?.partId },
          removeProductionInformation,
          setActionsModalOpen,
          setIsRemovingPI,
        }),
    },
  ];

  return <ActionMenu {...{ C, items, ...(minWidth ? { minWidth } : {}) }} />;
};

export default connect(
  ({ details: { parts, isEditModeForPartSwitchOn }, machinesV2: { isRemovingPI } }) => ({
    parts,
    isRemovingPI,
    isEditModeForPartSwitchOn,
  }),
  { setIsRemovingPI, removeProductionInformation, addProductionInformationV2, setIsEditModeForPartSwitchOn }
)(PartModal);
